import {
  action,
  observable,
  makeObservable,
  makeAutoObservable,
  runInAction,
  autorun,
  toJS,
} from 'mobx'
import {
  design_default_field,
  design_default_description,
  design_default_input,
  design_default_label,
} from '../AvailableFields/FieldDefinitions'
import { message } from 'antd'
import { produce } from 'immer'

import { observer } from 'mobx-react-lite'
import {
  getUser,
  getUsernameUser,
  getIsAdmin,
} from '../../../../utils/sessionManagement'
import { arrayMove } from '@dnd-kit/sortable'
import { useParams } from 'react-router-dom'
import {
  Form_getFormDetails,
  addCollaboratorAPI,
  updateFieldsAPI,
  Fields_getALL,
  updateFormAPI,
  collectFormAnswersData,
} from '../../../../services/api'
import useWebSocket from 'react-use-websocket'
import config from '../../../../config'
import { nanoid } from 'nanoid'
import { useMemo, useRef, useEffect } from 'react'
import React from 'react'

import { AnswersStore } from '../../../AnswersV3/components/store/store.Answers'

// Autres importations...

class BuilderStore {
  currentPage = 1
  pageSize = 10 // nombre d'éléments par page
  initialFetchComplete = false
  isSidebarFieldsOpen = true
  isSidebarEditorOpen = true
  isBarButtonVisible = true
  isEditingText = false
  isDragging = false
  selectedField = null
  selectedFieldParent = null
  canvasSize = 'Desktop'
  style = {}
  userFullName = getUser()
  userUsername = getUsernameUser()
  isAdmin = getIsAdmin()
  hasPermission = null
  url_code = null
  formDataAPI = null
  collaboratorsDataAPI = []
  RestrictedSubmissionsDataAPI = []
  EmailNotificationsGroupDataAPI = []
  styleForm = []
  userPermission = null
  themeColor = 'Light'

  formHistory = [] // Historique des états
  undoneStates = [] // États après annulation

  //DragAndDrop
  activeSidebarField = null
  activeField = null
  sidebarFieldsRegenKey = Date.now()
  selectedField = null
  data = { fields: [] }
  isPermissionChecked = false
  test = {}
  fieldIdToIndexMap = observable.map()
  // WEBSOCKET
  webSocketID = null
  dataFull = {}

  //DESIGN DEFAULT
  selectedFieldDefaultDesign = null
  field_default_design = []
  label_default_design = []
  description_default_design = []
  input_default_design = []

  // AnswersOfForm
  collectGetAnswerForm = { headers: [], rows: [] }

  // AUTRES STORES
  AnswersStore

  // Autres états ici...
  constructor(url_code) {
    this.url_code = url_code
    this.currentPage = 0
    makeAutoObservable(this)
    this.AnswersStore = new AnswersStore(url_code)
  }

  // Pour ajouter un nouvel état à l'historique
  addStateToHistory(newState) {
    runInAction(() => {
      if (this.formHistory.length >= 25) {
        this.formHistory.shift() // supprime le plus ancien si on dépasse 10 états
      }

      this.formHistory.push(newState)
    })
  }

  // Pour annuler la dernière action
  undo = action(() => {
    if (this.formHistory.length > 0) {
      const lastState = this.formHistory.pop()

      const thisform = {
        form: toJS(this.styleForm),
        fields: toJS(this.data.fields),
      }
      this.undoneStates.push(thisform)

      console.log('BEFORE UPDATE')
      console.log('BEFORE UPDATE styleForm', toJS(this.styleForm))
      console.log('BEFORE UPDATE data.fields', toJS(this.data.fields))
      console.log('BEFORE UPDATE IN HISTORY', toJS(lastState.fields))

      this.initialiseFormsWebSocket(lastState.form)
      this.initialiseFieldsWebSocket(lastState.fields)

      console.log('AFTER UPDATE')
      console.log('AFTER UPDATE styleForm', toJS(this.styleForm))
      console.log('AFTER UPDATE data.fields', toJS(this.data.fields))
      console.log('Je dois faire un undo', toJS(lastState))
      this.updateForm()
      this.updateFields()
    }
  })

  // Pour rétablir une action annulée
  // Pour rétablir une action annulée
  redo = action(() => {
    if (this.undoneStates.length > 0) {
      const stateToRestore = this.undoneStates.pop()

      const thisform = {
        form: toJS(this.styleForm),
        fields: toJS(this.data.fields),
      }
      // Enregistrer l'état actuel avant d'appliquer le redo, pour pouvoir undo si nécessaire
      this.formHistory.push(thisform)

      // Restaure l'état sauvegardé dans undoneStates
      this.initialiseFormsWebSocket(stateToRestore.form)
      this.initialiseFieldsWebSocket(stateToRestore.fields)

      console.log('Je dois faire un redo')
      this.updateForm()
      this.updateFields()
    }
  })

  updateUserPermission() {
    runInAction(() => {
      // Check if the user is an admin
      this.isAdmin = getIsAdmin()

      if (this.isAdmin) {
        // Si l'utilisateur est un administrateur, lui accorder automatiquement des droits élevés
        this.userPermission = 'write'
        this.hasPermission = true
      } else {
        // Sinon, vérifiez si l'utilisateur est un collaborateur
        this.hasPermission = this.collaboratorsDataAPI.some(
          (collaborator) => collaborator.username === this.userUsername
        )

        // S'il est un collaborateur, récupérez son niveau de permission
        if (this.hasPermission) {
          const userCollaborator = this.collaboratorsDataAPI.find(
            (collaborator) => collaborator.username === this.userUsername
          )

          // Suppose que 'permission' est une propriété de l'objet 'collaborator'
          this.userPermission = userCollaborator.permission
        } else {
          this.userPermission = null
        }
      }

      console.log('Admin', this.isAdmin)
      console.log('Acces', this.hasPermission)
      console.log('Droits', this.userPermission)
    })
  }

  updateSetSelectedFieldDefaultDesignAfterSocket() {
    runInAction(() => {
      if (
        this.selectedFieldDefaultDesign &&
        this.selectedFieldDefaultDesign.type
      ) {
        switch (this.selectedFieldDefaultDesign.type) {
          case 'field':
            console.log('Before', toJS(this.selectedFieldDefaultDesign))
            this.selectedFieldDefaultDesign = {
              ...this.selectedFieldDefaultDesign,
              data: this.styleForm.template_design?.design,
            }
            console.log('After', toJS(this.selectedFieldDefaultDesign))
            break
          case 'label':
            this.selectedFieldDefaultDesign = {
              ...this.selectedFieldDefaultDesign,
              data: this.styleForm.template_design?.label_design,
            }
            break
          case 'description':
            this.selectedFieldDefaultDesign = {
              ...this.selectedFieldDefaultDesign,
              data: this.styleForm.template_design?.description_design,
            }
            break
          case 'input':
            this.selectedFieldDefaultDesign = {
              ...this.selectedFieldDefaultDesign,
              data: this.styleForm.template_design?.input_default_design,
            }
            break
        }
      }
    })
  }

  updateDefaultDesign() {
    try {
      this.field_default_design = this.styleForm.template_design?.design
      this.label_default_design = this.styleForm.template_design?.label_design
      this.description_default_design =
        this.styleForm.template_design?.description_design
      this.input_default_design = this.styleForm.template_design?.input_design
    } catch (error) {
      console.log(
        'Une erreur est survenue lors de updateDefaultDesign : ',
        error
      )
    }
  }

  async initialisationGET() {
    try {
      const formDetails = await Form_getFormDetails(this.url_code)

      runInAction(() => {
        this.formDataAPI = formDetails
        this.styleForm = this.formDataAPI
        this.collaboratorsDataAPI = this.formDataAPI.collaborators
        this.RestrictedSubmissionsDataAPI =
          this.formDataAPI.restricted_submissions_group
        this.EmailNotificationsGroupDataAPI =
          this.formDataAPI.email_notifications_group

        console.log('styleForm', toJS(this.styleForm))

        this.updateUserPermission()
        this.updateDefaultDesign()

        this.isPermissionChecked = true
      })
    } catch (error) {
      console.log(
        'Une erreur est survenue lors de la récupération des détails du formulaire : ',
        error
      )
      this.hasPermission = false
      runInAction(() => {
        this.isPermissionChecked = true
      })
    }
  }

  async initialisationGETCollectFormAnswersData() {
    try {
      const formDetailsArray = await collectFormAnswersData(
        this.url_code,
        this.currentPage + 1,
        this.pageSize
      )
      runInAction(() => {
        this.collectGetAnswerForm = formDetailsArray
        console.log('delta', formDetailsArray)
      })
    } catch (error) {
      console.log(
        'Une erreur est survenue lors de la récupération des détails du formulaire : ',
        error
      )
    }
  }

  setCurrentPage(pageIndex) {
    runInAction(() => {
      this.currentPage = pageIndex
    })
  }

  setpageSize(pageIndex) {
    runInAction(() => {
      this.pageSize = pageIndex
    })
  }

  async initialiseFields() {
    try {
      const fields = await Fields_getALL(this.url_code)
      runInAction(() => {
        this.data.fields = fields.map((field, index) => ({
          ...field,
          id: field.idFieldCanvas,
          type: field.field_type,
          name: `${field.field_type}${index}`,
        }))
        console.log('initialiseFields', toJS(this.data.fields))
      })
    } catch (error) {
      console.error(
        'Une erreur est survenue lors de la récupération des champs : ',
        error
      )
    }
  }

  async initialiseFormsWebSocket(form) {
    const FIELD_TYPES = {
      FORM: 'form',
      BUTTON: 'button',
    }
    try {
      if (typeof form !== 'object') {
        throw new Error("Le formulaire reçu n'est pas un objet valide")
      }

      runInAction(() => {
        this.styleForm = form
        this.updateDefaultDesign()
        this.updateSetSelectedFieldDefaultDesignAfterSocket()

        const { typeSelected, url_code } = this.selectedField || {}

        if (
          this.selectedField &&
          typeSelected === FIELD_TYPES.FORM &&
          url_code === this.styleForm.url_code
        ) {
          this.setSelectedField({ ...this.styleForm }, FIELD_TYPES.FORM)
        } else if (this.selectedField && typeSelected === FIELD_TYPES.BUTTON) {
          this.setSelectedField(
            {
              design: this.styleForm.design_button,
              id: this.styleForm.url_code,
            },
            FIELD_TYPES.BUTTON
          )
        }
      })
    } catch (error) {
      console.error(
        'Une erreur est survenue lors de la récupération du formulaire : ',
        error
      )
    }
  }

  async initialiseFieldsWebSocket(fields) {
    try {
      console.log('Debut InitialiseFieldsWebsocket', toJS(fields))
      const FIELD_TYPES = {
        FIELD: 'field',
        LABEL: 'label',
        INPUT: 'input',
        DESCRIPTION: 'description',
      }

      runInAction(() => {
        this.data.fields = fields.map((field, index) => {
          // Gestion d'erreur pour field_type et type
          let fieldType = field.field_type
          if (!fieldType) {
            if (field.type) {
              fieldType = field.type
            } else {
              console.error(
                'Le champ n’a pas de field_type ni de type valides.'
              )
              return field // Retourne le champ original si aucune modification n’est nécessaire.
            }
          }

          // Gestion d'erreur pour idFieldCanvas et id
          let fieldId = field.idFieldCanvas
          if (!fieldId) {
            if (field.id) {
              fieldId = field.id
            } else {
              console.error('Le champ n’a pas d’idFieldCanvas ni d’id valides.')
              return field // Retourne le champ original si aucune modification n’est nécessaire.
            }
          }

          const updatedField = {
            ...field,
            id: fieldId,
            type: fieldType,
            name: `${fieldType}${index}`,
          }

          if (this.selectedField && this.selectedField.id === fieldId) {
            const { typeSelected } = this.selectedField

            switch (typeSelected) {
              case FIELD_TYPES.FIELD:
                this.setSelectedField(
                  { ...updatedField, id: updatedField.id },
                  typeSelected
                )
                break
              case FIELD_TYPES.LABEL:
                this.setSelectedField(
                  { design: updatedField.label_design, id: updatedField.id },
                  typeSelected
                )
                break
              case FIELD_TYPES.INPUT:
                this.setSelectedField(
                  { design: updatedField.input_design, id: updatedField.id },
                  typeSelected
                )
                break
              case FIELD_TYPES.DESCRIPTION:
                this.setSelectedField(
                  {
                    design: updatedField.description_design,
                    id: updatedField.id,
                  },
                  typeSelected
                )
                break
              default:
                throw new Error(`TypeSelected ${typeSelected} non reconnu.`)
            }
          }

          return updatedField
        })
      })
    } catch (error) {
      console.error(
        'Une erreur est survenue lors de la récupération des champs : ',
        error
      )
    }
  }

  handleClickOnInput(event, field) {
    console.log('Clic sur l input store')

    try {
      this.setSelectedField(
        { design: field.input_design, id: field.id },
        'input'
      )
    } catch (error) {
      console.error(
        'Error in EditableLabel in setSelectedField:',
        error.message
      )
    }
  }

  //DEFAULT DESGIN

  setSelectedFieldDefaultDesign(array) {
    runInAction(() => {
      this.selectedFieldDefaultDesign = array
      console.log(toJS(array))
    })
  }

  setIsDragging(bool) {
    runInAction(() => {
      this.isDragging = bool
    })
  }

  setField_default_design(field) {
    this.field_default_design = field
  }

  setEditingText(bool) {
    this.isEditingText = bool
    console.log(this.isEditingText)
  }

  setLabel_default_design(field) {
    this.label_default_design = field
  }

  setDescription_default_design(field) {
    this.description_default_design = field
  }

  setInput_default_design(field) {
    this.input_default_design = field
  }

  // DRAG AND DROP
  setActiveSidebarField(field) {
    this.activeSidebarField = field
  }
  setIsBarButtonVisible(value) {
    this.isBarButtonVisible = value
  }
  setActiveField(field) {
    this.activeField = field
  }

  setWebSocketID(id) {
    this.webSocketID = id
  }

  changeThemeColor = action(() => {
    if (this.themeColor === 'Light') {
      this.themeColor = 'Dark'
    } else if (this.themeColor === 'Dark') {
      this.themeColor = 'Light'
    }
    console.log(toJS(this.themeColor))
  })

  setSidebarFieldsRegenKey(key) {
    this.sidebarFieldsRegenKey = key
  }

  setSelectedField(field, typeSelected) {
    if (field === null) {
      this.selectedField = null
    } else {
      try {
        if (!field || typeof field !== 'object') {
          throw new Error('Error in setSelectedField, Invalid field object')
        }

        // Vérifiez si field.id existe et cherchez dans this.data.fields
        try {
          if (field.id) {
            const foundField = this.data.fields.find((f) => f.id === field.id)
            if (foundField) {
              this.selectedFieldParent = foundField
            } else {
              console.warn(
                `Field with ID ${field.id} was not found in data.fields.`
              )
            }
          }
        } catch (error) {
          console.error(
            'Error in foundField in setSelectedField:',
            error.message
          )
        }

        this.selectedField = {
          ...field,
          typeSelected: typeSelected || 'defaultType',
        }
        console.log('setSelectedField', toJS(this.selectedField))
      } catch (error) {
        console.error('Error in setSelectedField:', error.message)
      }
    }
  }

  setData(data) {
    this.data = data
  }

  prepareAndAddToHistory(form, fields) {
    const thisform = {
      form: form,
      fields: fields,
    }

    console.log('JENREGISTRE DANS LHISTORY POUR CTL Z', toJS(thisform))

    this.addStateToHistory(thisform)
    console.log(
      'JAI ENREGISTRE CA DANS LHISTORY POUR CTL Z',
      toJS(this.formHistory)
    )
  }

  async updateForm() {
    try {
      // Convertir les données en format nécessaire
      const form = this.styleForm

      // Préparer les données à envoyer
      const formData = {
        form__url_code: this.url_code, // Assumer que `this.url_code` contient le code URL de formulaire
        form_content: form,
        websocketID: this.webSocketID,
      }

      // Appeler l'API
      await updateFormAPI(formData, this.url_code)
    } catch (error) {
      console.error('Erreur lors de la mise à jour :', error)
    }
  }

  async updateFields() {
    try {
      // Convertir les données en format nécessaire
      const fields = this.data.fields.map((field) => ({
        ...field,
        idFieldCanvas: field.id,
        field_type: field.type,
      }))

      // Préparer les données à envoyer
      const formData = {
        form__url_code: this.url_code,
        fields: fields,
        websocketID: this.webSocketID,
      }

      // Appeler l'API
      await updateFieldsAPI(formData)
    } catch (error) {
      console.error('Erreur lors de la mise à jour updateFields:', error)
    }
  }

  showData() {
    console.log('showData', this.data.fields)
  }

  updateData(callback) {
    runInAction(() => {
      this.data = produce(this.data, callback)
    })
  }

  // Méthodes pour gérer les champs (fields)

  addField(field) {
    runInAction(() => {
      this.data.fields.push(field)
      this.fieldIdToIndexMap.set(field.id, this.data.fields.length - 1)
    })
  }

  removeField(fieldId) {
    runInAction(() => {
      const index = this.fieldIdToIndexMap.get(fieldId)
      if (index !== undefined) {
        try {
          this.data.fields.splice(index, 1)
          this.fieldIdToIndexMap.delete(fieldId)
          // Mise à jour des indices pour tous les champs après celui qui a été supprimé
          for (let i = index; i < this.data.fields.length; i++) {
            this.fieldIdToIndexMap.set(this.data.fields[i].id, i)
          }
        } catch (error) {
          console.error('Erreur lors de removeField :', error)
        }
      }
    })
  }

  moveField(fromIndex, toIndex) {
    runInAction(() => {
      if (toIndex >= 0 && toIndex < this.data.fields.length) {
        console.log('datafield à ce moment ', toJS(this.data.fields))
        try {
          const movedField = this.data.fields[fromIndex]
          this.data.fields = arrayMove(this.data.fields, fromIndex, toIndex)
          // Mise à jour des indices pour tous les champs qui ont été déplacés
          const minUpdatedIndex = Math.min(fromIndex, toIndex)
          const maxUpdatedIndex = Math.max(fromIndex, toIndex)
          for (let i = minUpdatedIndex; i <= maxUpdatedIndex; i++) {
            this.fieldIdToIndexMap.set(this.data.fields[i].id, i)
          }
        } catch (error) {
          console.error('Erreur lors de moveField :', error)
        }
      }
    })
  }

  setSelectedFieldByIdAndType(id, type) {
    console.log('setSelectedFieldByIdAndType debut', id, type)
    // Trouver le champ correspondant par ID et type
    const field = this.data.fields.find((field) => field.id === id)

    const designTypes = {
      field: () => ({ ...field }),
      label: () => ({ design: { ...field.label_design } }),
      description: () => ({ design: { ...field.description_design } }),
      input: () => ({ design: { ...field.input_design } }),
    }

    // Si le champ a été trouvé, le définir comme selectedField
    if (field) {
      console.log('field', toJS(field))

      if (!designTypes[type]) {
        throw new Error(`TypeSelected ${type} non reconnu.`)
      }

      runInAction(() => {
        this.setSelectedField(
          {
            ...designTypes[type](),
            id: field.id,
          },
          type
        )
      })

      console.log('setSelectedFieldByIdAndType', toJS(this.selectedField))
    } else {
      console.error(`Field with ID ${id} and type ${type} was not found.`)
    }
  }

  removeAllSpacers() {
    runInAction(() => {
      try {
        this.data.fields = this.data.fields.filter((f) => f.type !== 'spacer')
      } catch (error) {
        console.error('Erreur lors de removeAllSpacers :', error)
      }
    })
  }

  // Méthodes pour gérer les champs (fields)

  setActiveSidebarField(field) {
    runInAction(() => {
      this.activeSidebarField = field
    })
  }

  setActiveField(field) {
    runInAction(() => {
      this.activeField = field
    })
  }

  setActiveField(field, isSidebarField = false) {
    runInAction(() => {
      if (isSidebarField) {
        this.activeSidebarField = field
      } else {
        this.activeField = field
      }
    })
  }

  insertField(field, index) {
    runInAction(() => {
      this.data.fields.splice(index, 0, field)
    })
  }

  replaceField(field, index) {
    runInAction(() => {
      this.data.fields.splice(index, 1, field)
    })
  }

  // DRAG AND DROP

  addCollaborator(collaborator) {
    runInAction(() => {
      this.collaboratorsDataAPI.push(collaborator)
    })
  }

  removeCollaborator(collaboratorId) {
    runInAction(() => {
      this.collaboratorsDataAPI = this.collaboratorsDataAPI.filter(
        (collaborator) => collaborator.id !== collaboratorId
      )

      this.updateUserPermission()
    })
  }

  updateCollaborator(updatedCollaborator) {
    runInAction(() => {
      this.collaboratorsDataAPI = this.collaboratorsDataAPI.map(
        (collaborator) => {
          return collaborator.id === updatedCollaborator.id
            ? updatedCollaborator
            : collaborator
        }
      )

      this.updateUserPermission()
    })
  }

  addRestrictedSubmissions(collaborator) {
    runInAction(() => {
      this.RestrictedSubmissionsDataAPI.push(collaborator)
    })
  }

  removeRestrictedSubmissions(collaboratorId) {
    runInAction(() => {
      console.log('Resticted', toJS(this.RestrictedSubmissionsDataAPI))
      this.RestrictedSubmissionsDataAPI =
        this.RestrictedSubmissionsDataAPI.filter(
          (collaborator) => collaborator.id !== collaboratorId
        )

      console.log('Resticted AFTER', toJS(this.RestrictedSubmissionsDataAPI))
    })
  }

  updateRestrictedSubmissions(updatedCollaborator) {
    runInAction(() => {
      this.RestrictedSubmissionsDataAPI = this.RestrictedSubmissionsDataAPI.map(
        (collaborator) => {
          return collaborator.id === updatedCollaborator.id
            ? updatedCollaborator
            : collaborator
        }
      )
    })
  }

  addEmailNotificationsGroup(collaborator) {
    runInAction(() => {
      this.EmailNotificationsGroupDataAPI.push(collaborator)
    })
  }

  removeEmailNotificationsGroup(collaboratorId) {
    runInAction(() => {
      console.log('EmailGroup', toJS(this.EmailNotificationsGroupDataAPI))
      this.EmailNotificationsGroupDataAPI =
        this.EmailNotificationsGroupDataAPI.filter(
          (collaborator) => collaborator.id !== collaboratorId
        )

      console.log('EmailGroup AFTER', toJS(this.EmailNotificationsGroupDataAPI))
    })
  }

  updateEmailNotificationsGroup(updatedCollaborator) {
    runInAction(() => {
      this.EmailNotificationsGroupDataAPI =
        this.EmailNotificationsGroupDataAPI.map((collaborator) => {
          return collaborator.id === updatedCollaborator.id
            ? updatedCollaborator
            : collaborator
        })
    })
  }

  changeCanvasSize(value) {
    this.canvasSize = value
  }

  toggleSidebarFields = action(() => {
    this.isSidebarFieldsOpen = !this.isSidebarFieldsOpen
  })

  toggleSidebarEditor = action(() => {
    this.isSidebarEditorOpen = !this.isSidebarEditorOpen
  })

  getCanvasSizeClassName = () => {
    const bothSidebarsClosed =
      !this.isSidebarFieldsOpen && !this.isSidebarEditorOpen
    const oneSidebarClosed =
      !this.isSidebarFieldsOpen || !this.isSidebarEditorOpen

    if (bothSidebarsClosed) return 'expanded-full'
    if (oneSidebarClosed) return 'expanded-half'

    return ''
  }

  get fields() {
    return this.data.fields
  }

  handleDragField = action((listeners) => {
    const { onClick, ...otherListeners } = listeners
    return otherListeners
  })

  handleEditButtonClick = action((field) => {
    console.log('handleEditButtonClick')
    this.selectedField = field
    // console.log(field)
  })

  setStyle(newStyle) {
    this.style = newStyle
  }

  setStyleFormQRCode_design = action((newStyle) => {
    this.styleForm.qr_code_design = newStyle
    this.updateForm()
  })

  handleUpdateForm = action((newStyle) => {
    this.styleForm = newStyle
    this.updateForm()
  })

  setStyleFormQRCode_designWithoutSave = action((newStyle) => {
    this.styleForm.qr_code_design = newStyle
  })

  handleChangeStyle = action((name, value) => {
    if (this.selectedField?.url_code === this.url_code) {
      const newStyleForm = { ...this.styleForm, [name]: value }
      this.handleFieldUpdate({ ...this.selectedField, ...newStyleForm })
      this.styleForm = newStyleForm
    } else {
      const newStyle = { ...this.style, [name]: value }
      this.handleFieldUpdate({ ...this.selectedField, ...newStyle })
      this.style = newStyle
    }
  })

  handleDeleteField = action((id) => {
    try {
      this.prepareAndAddToHistory({ ...toJS(this.styleForm) }, [
        ...toJS(this.data.fields),
      ])
      this.data.fields = this.data.fields.filter((field) => field.id !== id)
      this.updateFields()
    } catch (error) {
      console.error('Erreur lors de handleDeleteField :', error)
    }

    if (this.selectedField?.id === id) {
      this.setSelectedField(null)
    }
  })

  handleDuplicate = action((id) => {
    try {
      this.prepareAndAddToHistory({ ...toJS(this.styleForm) }, [
        ...toJS(this.data.fields),
      ])

      const index = this.data.fields.findIndex((f) => f.id === id)
      const field = this.data.fields[index]

      if (field) {
        const newField = { ...field, id: nanoid() }
        this.data.fields.splice(index + 1, 0, newField)

        // Sélection du nouveau champ dupliqué
        this.setSelectedField(newField, 'field')
      }

      this.updateFields()
    } catch (error) {
      console.error('Erreur lors de handleDuplicate :', error)
    }
  })

  handleMoveField = action((fromIndex, toIndex) => {
    try {
      this.prepareAndAddToHistory({ ...toJS(this.styleForm) }, [
        ...toJS(this.data.fields),
      ])

      if (toIndex >= 0 && toIndex < this.data.fields.length) {
        this.data.fields = arrayMove(this.data.fields, fromIndex, toIndex)
        this.updateFields()
      }
    } catch (error) {
      console.error('Erreur lors de handleMoveField :', error)
    }
  })

  handleUpdateDefaultDesign = action((updatedField, type) => {
    try {
      this.prepareAndAddToHistory({ ...toJS(this.styleForm) }, [
        ...toJS(this.data.fields),
      ])
      console.log('handleUpdateDefaultDesign', updatedField)
      switch (type) {
        case 'field':
          this.field_default_design = updatedField
          this.styleForm.template_design.design = updatedField
          break
        case 'label':
          this.label_default_design = updatedField
          this.styleForm.template_design.label_design = updatedField
          break
        case 'description':
          this.description_default_design = updatedField
          this.styleForm.template_design.description_design = updatedField
          break
        case 'input':
          this.input_default_design = updatedField
          this.styleForm.template_design.input_design = updatedField
          break
        default:
          console.warn(`Unknown type: ${type}`)
          return
      }
      this.selectedFieldDefaultDesign.data = updatedField
      this.updateForm()
    } catch (error) {
      console.error('Erreur lors de handleUpdateDefaultDesign :', error)
    }
  })

  updateFieldDesign = action((field, updatedField) => {
    console.log('ok je rentre avec ça', toJS(field), toJS(updatedField))
    switch (updatedField.typeSelected) {
      case 'field':
        Object.assign(field, { ...field, ...updatedField })
        break
      case 'label':
        field.label_design = updatedField.design
        break
      case 'description':
        field.description_design = updatedField.design
        break
      case 'input':
        field.input_design = updatedField.design
        break
      default:
        console.warn(`Unknown typeSelected: ${updatedField.typeSelected}`)
        break
    }
    console.log('ok je resort avec ça', toJS(field), toJS(updatedField))
  })

  handleFieldUpdate = action((updatedField, noUpdateSelectedField) => {
    try {
      this.prepareAndAddToHistory({ ...toJS(this.styleForm) }, [
        ...toJS(this.data.fields),
      ])
      if (updatedField?.typeSelected === 'form') {
        console.log('OUIIIIIII JE RENTRE LA')
        this.styleForm = updatedField
        this.selectedField = updatedField

        try {
          this.updateForm()()
        } catch (error) {}
      } else if (updatedField?.typeSelected === 'button') {
        console.log('OUIIIIIII JE RENTRE LA', updatedField)
        this.styleForm.design_button = updatedField.design
        this.selectedField = updatedField

        try {
          this.updateForm()()
        } catch (error) {}
      } else {
        console.log('OUIIIIIII JE RENTRE LALALA', updatedField)
        // Handle specific field update
        const field = this.data.fields.find(
          (field) => field.id === updatedField.id
        )
        if (field) {
          this.updateFieldDesign(field, updatedField)
          try {
            if (noUpdateSelectedField === true) {
            } else {
              this.selectedField = updatedField
            }
          } catch (error) {}
        } else {
          // Look for the field in nested fields of doubleCustom fields
          for (let field of this.data.fields) {
            if (field.type === 'doubleCustom') {
              const subField = field.fields.find(
                (subField) => subField.id === updatedField.id
              )
              if (subField) {
                this.updateFieldDesign(subField, updatedField)
                this.selectedField = updatedField
                break
              }
            }
          }
        }
        this.updateFields()
      }
    } catch (error) {
      console.error(`handleFieldUpdate error: ${error}`)
    }
  })

  handleAddCollaborator = async (formData, username) => {
    // Ajouter le collaborateur côté client immédiatement
    this.addCollaborator(username)

    // Essayer d'ajouter le collaborateur côté serveur
    try {
      await addCollaboratorAPI(formData)
      // Si l'appel API réussit, on ne fait rien de plus
    } catch (error) {
      console.error("Erreur lors de l'ajout du collaborateur :", error)
      // Si l'appel API échoue, retirer le collaborateur de la liste côté client
      this.removeCollaborator(username)
    }
  }
}

const BuilderContext = React.createContext()

const BuilderProvider = observer(({ children }) => {
  const { url_code } = useParams()
  const store = useMemo(() => new BuilderStore(url_code), [url_code])
  // Ici, utilisez l'API useEffect pour exécuter des actions d'initialisation et d'autres choses qui dépendent des changements de l'état du store
  // Le store est maintenant disponible pour les enfants
  return (
    <BuilderContext.Provider value={store}>{children}</BuilderContext.Provider>
  )
})

export { BuilderContext, BuilderProvider }
